window.config = {
    apiKey: 'pk_live_Gw8d0Uf60iZnhA0nsy8d7ho300xoSAa8oV',
    email: 'orders@letterbot.co.uk',
    zapierUrl: 'https://hooks.zapier.com/hooks/catch/3746077/o8ncq9d/silent/',
    vat: 0.20,
  	logoPrice: 0.08,
    successUrl: 'https://www.letterbot.co.uk/pages/psengine-success',
    cancelUrl: 'https://www.letterbot.co.uk/pages/psengine-failure',
    products: [
        {
            name: 'A4 Letter',
            id: 'prod_HZYWQpEhnQIjhW'
        },
        {
            name: 'A5 Card',
            id: 'prod_HZYXBAxcyOIYWr'
        },
        {
            name: 'print',
            id: 'prod_HZYYnKXqUH2oKk',
        }
    ],
}